import { Ymal } from './ymalTypes';

const defaultState: Ymal = {
  articleGroups: [],
  articles: [],
  ymal: [],
};

export default defaultState;
